module.exports = __webpack_public_path__ + "static/all_bg.71198449.png";